/** Display labels for the wire name-mismatch "Type" column (party / name source). */
export const NAME_MISMATCH_PARTY_ROLE_LABEL = {
	knownAlias: "Known Aliases",
	authorizedUser: "Authorized User",
	contactPerson: "Contact Person",
	beneficialOwner: "Beneficial Owner",
	officer: "Officer",
	customer: "Customer",
	org: "Org",
} as const

/**
 * Canonical key for matching assignment score map names to role map entries.
 * Apply when storing in the role map and when looking up from score map keys.
 */
export function normalizeNameMatchKey(name: string): string {
	return name.trim().replace(/\s+/g, " ").toLowerCase()
}

/** Join all distinct role labels for one matched name (stable order: first seen in buildNameRoleMap). */
export function formatNameMismatchTypesForDisplay(roles: string[] | undefined): string {
	if (!roles || roles.length === 0) {
		return "—"
	}
	return roles.join(" · ")
}
